import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  SelectBox,
  LeftContent,
  IconButton,
  Dropdown,
  SearchWrapper,
  SearchInput,
  Option,
  StyledPlaceholder,
  StyledSelected,
  LeftIcon,
  RightIcon,
} from './styled';
import { ReactComponent as DownIcon } from 'assets/icons/ui-elements/small/caret-down-sm.svg';
import { ReactComponent as UpIcon } from 'assets/icons/ui-elements/small/caret-up-sm.svg';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
import { ReactComponent as LupaIcon } from 'assets/icons/ui-elements/small/magnifying_glass_sm.svg';
export const SelectDropdown = ({
  options,
  onChange,
  value,
  size = 'medium',
  iconLeft,
  iconRight,
  searchable = false,
  clearable = false,
  placeholder,
  disabled = false,
  fontColor = '#7F746A',
  error = false,
  fontWeight = '700',
  width = 'auto',
  top = '64%',
  fontSize = '14px',
  showScrollbar = true,
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const dropdownRef = useRef(null);

  const selected = options.find(opt => opt.value === value);

  const filteredOptions = options.filter(opt => opt.label.toLowerCase().includes(query.toLowerCase()));

  const handleClear = e => {
    e.stopPropagation();
    onChange(null);
  };
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <Wrapper width={width} ref={dropdownRef} fontSize={fontSize}>
      <SelectBox
        error={error}
        size={size}
        onClick={() => !disabled && setOpen(prev => !prev)}
        isOpen={open}
        width={width}
        disabled={disabled}
      >
        <LeftContent>
          {iconLeft && iconLeft}
          {selected?.label ? (
            <StyledSelected fontWeight={fontWeight} fontColor={fontColor}>
              {selected.label}
            </StyledSelected>
          ) : (
            <StyledPlaceholder>{placeholder}</StyledPlaceholder>
          )}
        </LeftContent>
        <LeftContent>
          {clearable && selected ? (
            <IconButton onClick={handleClear}>
              <XIcon />
            </IconButton>
          ) : (
            <>
              {iconRight && iconRight}
              <IconButton>{open ? <UpIcon /> : <DownIcon />}</IconButton>
            </>
          )}
        </LeftContent>
      </SelectBox>
      {open && (
        <Dropdown isSearchable={searchable} top={top} showScrollbar={showScrollbar}>
          {searchable && (
            <SearchWrapper size={size}>
              <LeftIcon>
                <LupaIcon />
              </LeftIcon>
              <SearchInput placeholder="Buscar..." value={query} onChange={e => setQuery(e.target.value)} />
              <RightIcon onClick={() => setOpen(prev => !prev)}>
                <UpIcon />
              </RightIcon>
            </SearchWrapper>
          )}
          {filteredOptions.map(option => (
            <Option
              size={size}
              fontColor={fontColor}
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
            >
              {option.label}
            </Option>
          ))}
        </Dropdown>
      )}
    </Wrapper>
  );
};

SelectDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  searchable: PropTypes.bool,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
};
